import Nullstack from 'nullstack';
export default function IconTimeline({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-timeline",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M4 16l6 -7l5 5l5 -6"
  }), "   ", Nullstack.element("circle", {
    cx: "15",
    cy: "14",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "10",
    cy: "9",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "4",
    cy: "16",
    r: "1"
  }), "   ", Nullstack.element("circle", {
    cx: "20",
    cy: "8",
    r: "1"
  }), " ");
}